// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"365":"graph-view","895":"vendors-graphiql-console"}[chunkId] + "." + {"365":"99a77d38","895":"7e53da46"}[chunkId] + ".css";
};